import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';

const positionMap = {
	center: 'items-center justify-center',
	top: 'items-start justify-center',
	bottom: 'items-end justify-center',
	left: 'items-center justify-start',
	right: 'items-center justify-end',
};

let openModalCount = 0;

const Modal = (props) => {
	const { isOpen = false, onClose = () => {}, children = null, position = 'center' } = props;
  
	const dispatchModalChange = () => {
		window.dispatchEvent(new CustomEvent('modal:change', { detail: { isOpen: openModalCount > 0 } }));
	};

	const notifyModalOpen = () => {
		openModalCount += 1;
		dispatchModalChange();
	};

	const notifyModalClose = () => {
		openModalCount = Math.max(0, openModalCount - 1);
		dispatchModalChange();
	};

	useEffect(() => {
		if (!isOpen) return;

		notifyModalOpen();
		return () => {
			notifyModalClose();
		};
	}, [isOpen]);

	if (!isOpen) return null;

	const handleBackdropClick = (e) => {
		if (e.target === e.currentTarget) {
			onClose();
		}
	};

	return createPortal(
		<div className={`fixed inset-0 z-50 flex ${positionMap[position]} bg-gray-800 bg-opacity-70 transition-opacity duration-200`} onClick={handleBackdropClick}>
			<div className='bg-white rounded-2xl shadow-lg max-w-md w-full transform transition duration-300 scale-100 m-4'>{children}</div>
		</div>,
		document.body
	);
};

export default Modal;
